<!-- /test: tools for admins and test users (fullstack server/services/tests/getIsTester.js) to
     check behaviour that otherwise only shows at a set time. One section per test group: add a
     group to TEST_GROUPS. Anyone else is sent to the home page, as this route always did. -->
<template>
  <template v-if="hasAccess">
    <h3>Tests</h3>
    <p class="clock">
      Server now: <b>{{ londonNow }}</b> (London)
      <template v-if="isOverridden">
        · test time, this session only
        <button class="clear" @click="clearOverride">Back to Real Time</button>
      </template>
    </p>
    <section v-for="group in TEST_GROUPS" :key="group.name" class="group">
      <h4>{{ group.name }}</h4>
      <component :is="group.component" />
    </section>
  </template>
</template>

<script setup>
import {ref, watch, onBeforeUnmount} from "vue";
import {useRouter} from "vue-router";
import {authFetch} from "@/composables/useAuthFetch";
import useUserSafe from "@/composables/useUserSafe";
import useServerClock, {clearClockOverride} from "@/composables/useServerClock";
import GoLive from "@/components/Test/GoLive.vue";

const TEST_GROUPS = [{name: "Go Live", component: GoLive}];
const LONDON = "Europe/London";

const router = useRouter();
const {isLoaded, isSignedIn} = useUserSafe();
const {getServerNow, isOverridden} = useServerClock();
const hasAccess = ref(false);
const londonNow = ref("");

function getLondonNow() {
  return getServerNow().setZone(LONDON).toFormat("d LLL yyyy, HH:mm:ss");
}

// the server decides (admins and test users); anyone else goes home
async function checkAccess() {
  if (!isSignedIn.value) return router.replace("/");
  const response = await authFetch("/api/v1/user/clock-override", {cache: "no-store"});
  if (!response.ok) return router.replace("/");
  hasAccess.value = true;
}

const clearOverride = clearClockOverride;

const stopWaiting = watch(isLoaded, (loaded) => loaded && checkAccess(), {immediate: true});
const tick = setInterval(() => (londonNow.value = getLondonNow()), 250);
onBeforeUnmount(() => {
  stopWaiting();
  clearInterval(tick);
});
</script>

<style scoped>
.clock {
  font-variant-numeric: tabular-nums;
}
.clear {
  margin-left: 0.5rem;
}
.group {
  margin-top: 1.5rem;
}
</style>
